import { render, staticRenderFns } from "./aws-form.vue?vue&type=template&id=1a9e98eb&"
import script from "./aws-form.vue?vue&type=script&lang=js&"
export * from "./aws-form.vue?vue&type=script&lang=js&"
import style0 from "./aws-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports